/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APITokenRefresh
 */
export interface APITokenRefresh {
    /**
     * 
     * @type {string}
     * @memberof APITokenRefresh
     */
    readonly access: string;
}

/**
 * Check if a given object implements the APITokenRefresh interface.
 */
export function instanceOfAPITokenRefresh(value: object): value is APITokenRefresh {
    if (!('access' in value) || value['access'] === undefined) return false;
    return true;
}

export function APITokenRefreshFromJSON(json: any): APITokenRefresh {
    return APITokenRefreshFromJSONTyped(json, false);
}

export function APITokenRefreshFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITokenRefresh {
    if (json == null) {
        return json;
    }
    return {
        
        'access': json['access'],
    };
}

export function APITokenRefreshToJSON(value?: Omit<APITokenRefresh, 'access'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
    };
}

